import { atom } from 'jotai'
import { atomWithStorage, createJSONStorage } from 'jotai/utils'
import { atomWithSearchParams } from 'jotai-location'

export const settingsSidebarAtom = atomWithStorage<boolean>(
  'sidebar_state',
  true,
  createJSONStorage(() => sessionStorage)
)

export const dashboardRoomUrlAtom = atomWithSearchParams('room', '')

export const dashboardRoomStorageAtom = atomWithStorage<string>(
  'dashboard_room',
  'all',
  createJSONStorage(() => sessionStorage)
)

export const dashboardRoomAtom = atom(
  (get) => {
    const urlValue = get(dashboardRoomUrlAtom)
    const storageValue = get(dashboardRoomStorageAtom)
    return urlValue || storageValue
  },
  (_get, set, value: string) => {
    set(dashboardRoomUrlAtom, value === 'all' ? '' : value)
    set(dashboardRoomStorageAtom, value)
  }
)

export const dashboardSearchUrlAtom = atomWithSearchParams('search', '')

export const showStatisticsUrlAtom = atomWithStorage(
  'show_stats',
  false,
  createJSONStorage(() => sessionStorage)
)
